// extracted by mini-css-extract-plugin
var _1 = "PieGraph__correctFill--WaCBV";
var _2 = "PieGraph__lightGrayFill--SUuNx";
var _3 = "PieGraph__main--OdPPc";
var _4 = "PieGraph__printGray--xfyUm";
var _5 = "PieGraph__svg--F28cC";
var _6 = "PieGraph__text--Rn5FA";
var _7 = "PieGraph__white--E1VIf";
export { _1 as "correctFill", _2 as "lightGrayFill", _3 as "main", _4 as "printGray", _5 as "svg", _6 as "text", _7 as "white" }
